// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_EDIT_SUBMIT_HELP = "Nem\u00e1\u0161 v\u0161e vypln\u011bn\u00e9.";
export const CANCEL = "Zru\u0161";
export const DELETE = "Vyma\u017e";
export const DELETION_ENTER_REASON = "Napi\u0161 d\u016fvod smaz\u00e1n\u00ed";
